import DescriptionList from "@/components/description-list/DescriptionList";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PATH_SHIFT_REPORT, PATH_STORE } from "@/constants";
import { ReadShiftReport } from "@/types/shiftReport";
import { UseQueryResult } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { generatePath } from "react-router-dom";

interface TimesheetEntriesShiftReportsDirectoryHeaderProps {
  shiftReportQuery: UseQueryResult<ReadShiftReport>;
}

export const TimesheetEntriesShiftReportsDirectoryHeader = ({
  shiftReportQuery,
}: TimesheetEntriesShiftReportsDirectoryHeaderProps) => {
  const { t } = useTranslation();
  return (
    <Card className="mb-4">
      <CardHeader>
        <CardTitle>{t("timesheetEntries.title.multiple")}</CardTitle>
      </CardHeader>
      <CardContent>
        <DescriptionList
          data={shiftReportQuery.data || {}}
          translationKey="timesheetEntries.shiftReports.header"
          variant="ghost"
          className="py-4"
        >
          <DescriptionList.Content className="p-0">
            <DescriptionList.Link
              name="shift"
              to={generatePath(PATH_SHIFT_REPORT, {
                shiftReportId: shiftReportQuery.data?.id || "",
              })}
            />
            <DescriptionList.Link
              name="store_name"
              to={generatePath(PATH_STORE, {
                storeId: shiftReportQuery.data?.store_id || "",
              })}
            />
          </DescriptionList.Content>
        </DescriptionList>
      </CardContent>
    </Card>
  );
};
